module.exports = __webpack_public_path__ + "static/media/rides.1d4bea5e.svg";